/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {PackagingSelector} from "./SKUSelector";
import {RowCell} from "../../atoms/layout/RowCell";
import {getSkuWithNumber} from "../../../selectors/productPage";

const unitCellSizes = {xxs: 6, xs: 6, sm: 3};

const UnitColumn = ({current, label, options, setOption, sizes, className, isLast, hideDesktop = true}) => {

    return <RowCell sizes={{...sizes}}
                    className={`table-group-cell__value ${isLast ? "is-last" : ""} ${className}`}>
        {label && <label className={`text-muted p-tiny ${hideDesktop ? 'hide-desktop' : ''}`}>{label}</label>}
        <span className="p-serif-nr"/>
        <div>
            <PackagingSelector selected={getSkuWithNumber(options, current.materialNumber)?.materialNumber}
                               skus={options} onChange={setOption}/>
        </div>
    </RowCell>
};

UnitColumn.propTypes = {
    label: PropTypes.string,
    options: PropTypes.array,
    setOption: PropTypes.func,
};

UnitColumn.defaultProps = {
    className: "",
    sizes: unitCellSizes,
};

export default UnitColumn;
